var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoAccountLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "8cwnbuleka"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.910892 0 0 0 0 0.377655 0 0 0 0 0.268755 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#8cwnbuleka)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.857 5.143)",
    stroke: "#B6BFCE",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.707 8.893a1.715 1.715 0 1 1 3.43.001 1.715 1.715 0 0 1-3.43-.001z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 4.286,
    width: 11.143,
    height: 9.429,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.571 0a3 3 0 0 1 3 3v1.286h-6V3a3 3 0 0 1 3-3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAccountLock);
export default __webpack_public_path__ + "static/media/ico-account-lock.ad451c4f3c218769017e2818a830b3fc.svg";
export { ForwardRef as ReactComponent };